'use strict';

import 'normalize.css'
import "../css/base/variables.css"
import "../css/base/fonts.css"
import "../css/base/typography.css"
import "../css/base/grid.css"
import "../css/template/tmpl-header.css"
import "../css/template/tmpl-footer.css"
import "../css/template/tmpl-nav.css"
import "../css/base/nodata.css"



import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

/* push */
//global.appServerKey = 'BHZzgsS-PgnK1LQmwlRofEOvVhzghXtwQSQaja7U8ouRjqbsctm99-CSylbQrTDo-FIxTXXQBn6V9GJFmw55RcQ';
global.appServerKey = 'BEfe0jeoX1O7aFv1OvoJJyEdYO54RA1TKOmx3Vp2BaOSQm3wBF-RA6xdDcOgwFKDz2n6fko6w_B4oF7HFEls7N0'

/* END push */



window.Stimulus = Application.start()
const context = require.context("./controllers", true, /\.js$/)
Stimulus.load(definitionsFromContext(context))

global.usertoken = (window.location.search).slice(1);

global.hasSubscription = false;
global.serviceWorkerRegistration = null;


document.querySelector('#manifest').setAttribute('href', 'https://api.actualoptic.kz:8443/admin/manifest/'+global.usertoken);


if (sessionStorage.getItem("hasInstall")) {
    global.hasInstall = sessionStorage.getItem("hasInstall");
} else {
    global.hasInstall = "true";
    sessionStorage.setItem("hasInstall", global.hasInstall);
}